import React, { FC } from "react";
import { Divider } from "antd";
import { Loader, Page } from "shared/ui";
import {
  useGetMachineOverviewQuery,
  useGetUserOverviewQuery,
} from "shared/api";
import {
  MachineCard,
  OverviewSection,
  OverviewThisWeekTasks,
  UserCard,
} from "./ui";

const Overview: FC = () => {
  const { data: machines, isLoading: machinesLoading } =
    useGetMachineOverviewQuery();
  const { data: users, isLoading: usersLoading } = useGetUserOverviewQuery();

  const isLoading = machinesLoading || usersLoading;

  return (
    <Page title="Overview">
      {isLoading ? (
        <div className="flex min-h-[calc(100dvh-11rem)] w-full items-center justify-center px-4">
          <Loader />
        </div>
      ) : (
        <div className="flex flex-col overflow-hidden">
          <OverviewSection
            title="Machines"
            items={machines}
            renderItem={(item) => <MachineCard item={item} />}
            emptyDescription="No machine data available"
          />

          <Divider className="shrink-0" />

          <OverviewSection
            title="Users"
            items={users}
            renderItem={(item) => <UserCard item={item} />}
            emptyDescription="No user data available"
          />

          <Divider className="shrink-0" />

          <div className="flex h-[min(280px,32vh)] min-h-[192px] shrink-0 flex-col px-2 pb-2 pt-1">
            <OverviewThisWeekTasks />
          </div>
        </div>
      )}
    </Page>
  );
};

export { Overview };
